import React, {useEffect, useState} from "react";
import {Box, Typography,Tooltip} from "@mui/material";
import {ComposableMap, Geographies, Geography,} from "react-simple-maps";
import * as countries from "i18n-iso-countries";
import {GRADE_COLOR_MAPPING} from "../../utils/constants";

countries.registerLocale(require("i18n-iso-countries/langs/en.json"));
const geoUrl = "https://cdn.jsdelivr.net/npm/world-atlas@2/countries-110m.json";
const CosiMap = ({ globalGoalsChartData = {} }) => {
    const [mappedData, setMappedData] = useState({});

    useEffect(() => {
        const transformed = {};
        Object.entries(globalGoalsChartData).forEach(([code2, grade]) => {
            transformed[code2] = GRADE_COLOR_MAPPING[grade] || "#ccc";
        });
        setMappedData(transformed);
    }, [globalGoalsChartData]);


    return (
        <Box sx={{
            display: 'flex',
            position: "relative",
            flexDirection: {xs: 'column', sm: "row"},
            alignItems: 'center',
            justifyContent: 'space-between',
            minHeight: {md:'41vh',lg:'90vh'},
        }}>
            <Box sx={{marginLeft: {xs: '20px',md:'40px', lg: 9}, marginRight: {xs: '20px', md:undefined}, marginTop: {xs: '50px', md:0, lg: '170px'}, maxWidth: '360px'}}>
                <Typography sx={{
                    color: '#003C69',
                    fontSize: {xs: '25px', sm: '45px'},
                    fontWeight: 'bold',
                    lineHeight: '1.1',
                    marginBottom: 1
                }}>
                    <span style={{color: '#0096C8'}}>2025</span> <br/>
                    CHILD PROTECTION IN CYBERSPACE INDEX
                </Typography>
                <Typography sx={{
                    color: '#001A2D',
                    fontSize: {xs: '18px', sm: '25px'},
                    mt: 1,
                    fontWeight: 'normal',
                    lineHeight: '1.1'
                }}>
                    National-Level Measure to Guide Child Protection in Cyberspace Improvement
                </Typography>
            </Box>

            {/* Map Section */}
            <Box className="align-items-start" sx={{flexGrow: 1}}>
                <Box className="map-container" sx={{flexGrow: 1, minWidth: "360px",}}>
                    <ComposableMap projectionConfig={{ scale: 160 }}>
                        <Geographies geography={geoUrl}>
                            {({ geographies }) =>
                                geographies.map((geo) => {
                                    const countryName = geo.properties.name;
                                    const countryCode = countries.getAlpha2Code(countryName, "en");
                                    const fillColor = countryCode ? mappedData[countryCode] || "#E6E6E6" : "#E6E6E6";
                                    //console.log("Hi im",geo.properties);
                                    return (
                                        <Tooltip key={geo.rsmKey} title={geo.properties.name} arrow>
                                        <Geography
                                            key={geo.rsmKey}
                                            geography={geo}
                                            style={{
                                                default: {
                                                    fill: fillColor,
                                                    outline: "none",
                                                    transition: "fill 0.2s ease",
                                                    stroke: "#fff",
                                                    strokeWidth: 0.7,
                                                },
                                                hover: {
                                                    fill: fillColor + "CC",
                                                    outline: "none",
                                                    cursor: "pointer",
                                                },
                                                pressed: {
                                                    outline: "none",
                                                },
                                            }}
                                        />
                                        </Tooltip>
                                    );
                                })
                            }
                        </Geographies>
                    </ComposableMap>
                </Box>
                <Box className="cosi-leg" sx={{position: "absolute", bottom: '65px'}}>
                    <Typography sx={{display: "block", fontSize: '20px', mb: 2, fontWeight: "bold", color: '#0088C0'}}>
                        CPC Index Level
                    </Typography>
                    <Box className="quartile-legends" sx={{display: "flex", flexDirection: "column", gap: 3}}>
                        <Box sx={{display: "flex", flexDirection: "column", alignItems: "center"}}>
                            <Box sx={{display: "flex", width: {xs: '308px', sm: "430px"}, height: "12px"}}>
                                <Box sx={{flex: 1, backgroundColor: GRADE_COLOR_MAPPING['A']}}/>
                                <Box sx={{flex: 1, backgroundColor: GRADE_COLOR_MAPPING['B']}}/>
                                <Box sx={{flex: 1, backgroundColor: GRADE_COLOR_MAPPING['C']}}/>
                                <Box sx={{flex: 1, backgroundColor: GRADE_COLOR_MAPPING['D']}}/>
                            </Box>
                            <Box sx={{
                                display: "flex",
                                justifyContent: "space-evenly",
                                width: {xs: '308px', sm: "430px"},
                                marginTop: 1,
                                gap: '23px',
                            }}>
                                <Typography variant="body2" sx={{color: "#003C69", fontSize: {xs: '10px', sm: '14px'}}}>
                                    EXCEPTIONAL
                                </Typography>
                                <Typography variant="body2" sx={{color: "#003C69", fontSize: {xs: '10px', sm: '14px'}}}>
                                    EFFECTIVE
                                </Typography>
                                <Typography variant="body2" sx={{color: "#003C69", fontSize: {xs: '10px', sm: '14px'}}}>
                                    MODERATE
                                </Typography>
                                <Typography variant="body2" sx={{color: "#003C69", fontSize: {xs: '10px', sm: '14px'}}}>
                                    EMERGING
                                </Typography>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Box>

        </Box>
    );
};

export default CosiMap;
